import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';

export function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-9xl text-foreground mb-4 font-display text-page-title">404</h1>
        <h2 className="text-foreground mb-4 font-display text-section-title">Page Not Found</h2>
        <p className="text-muted-foreground mb-8">The page you're looking for doesn't exist.</p>
        <Link to="/">
          <Button variant="unstyled" size="unstyled" className="px-8 py-4 bg-primary hover:bg-primary/90 text-white font-semibold rounded-lg transition-colors shadow-lg shadow-primary/30">
            Go Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
